/**
 * `?tab=picker`, everything else on the URL preserved (FRAME_PICKER_DESIGN.md §6.1, §6.4).
 *
 * A PURE function over strings, for the anchors' `href`. The CLICK goes through
 * `state/picker-url.ts` (`openPickerTab`), which is what actually writes the URL and composes
 * with an in-flight write; the href exists so the link is a real link — middle-click, "open in
 * new tab", a reader mode, and a router that has not mounted all still work.
 *
 * Only the picker's own key is written (`tab`). The Studio's `sid`/`step`/`job` and the
 * picker's own `psid`/`pstep` are neither added nor cleared here: the picker owns its keys in
 * `state/picker-url.ts` and the Studio owns its four (§0 "Tab state"); a link that cleared them
 * would be the coupling the owner ruled out.
 *
 * The tab value is IMPORTED from `state/picker-url.ts`, never spelled here — one spelling, the
 * picker's — and re-exported so the nudge's callers keep their one import.
 */
import { PICKER_TAB_ID } from '../state/picker-url';

export { PICKER_TAB_ID };

export function pickerTabHref(pathname: string, search: string, hash = ''): string {
    const params = new URLSearchParams(search && search.charAt(0) === '?' ? search.slice(1) : search);
    params.set('tab', PICKER_TAB_ID);
    const path = pathname || '/';
    const frag = hash ? (hash.charAt(0) === '#' ? hash : `#${hash}`) : '';
    return `${path}?${params.toString()}${frag}`;
}

/** The href for the page on screen, or `null` when there is no window (SSR). */
export function currentPickerTabHref(): string | null {
    if (typeof window === 'undefined') return null;
    return pickerTabHref(window.location.pathname, window.location.search, window.location.hash);
}
